// Utility functions for components
export const classNames = (...classes) => classes.filter(Boolean).join(' ')
